import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  updateScreenPage,
  setLoading,
  updateNavigationKycStatus,
} from "../../../../redux";
import {
  getSegments,
  validateIncomeProof,
  handleFileUpload,
  handleCaptureFileUpload,
} from "./redux/action";
import { VACHANA_API_URL, makeid } from "./../../../../utils";
import Title from "../../components/Title";
import Button from "../../components/Button";
import Webcam from "react-webcam";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FileUploader } from "react-drag-drop-files";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import "./style.css";
import InputTitle from "designs/v1/components/InputTitle";
import { showPrevBtnByUrl, showNextBtnByUrl, getPrevAndNextRoute } from "utils";

const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";

const videoConstraints = {
  width: 220,
  height: 200,
  facingMode: FACING_MODE_USER,
};

const ViewModel = ({ show, handleClose, item }) => {
  return (
    <Modal
      show={show}
      onHide={() => handleClose(false)}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Image View</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={item?.src}
            style={{ width: "50%" }}
            alt=""
          />
          :
        </div>
      </Modal.Body>
    </Modal>
  );
};

const WebcamCapture = ({ handleImg, handleShow, disabled, show }) => {
  const [facingMode, setFacingMode] = useState(FACING_MODE_USER);
  const [image, setImage] = useState("");
  const webcamRef = React.useRef(null);

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
    handleImg(imageSrc);
  });

  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  const handleChangeMode = React.useCallback(() => {
    setFacingMode((prevState) =>
      prevState === FACING_MODE_USER
        ? FACING_MODE_ENVIRONMENT
        : FACING_MODE_USER
    );
  }, []);

  const handleClose = (bool) => {
    setImage("");
    handleShow(bool);
  };

  return (
    <>
      {show ? (
        <div className="webcam-container">
          <div className="webcam-img">
            {image == "" ? (
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width={"100%"}
                videoConstraints={{
                  ...videoConstraints,
                  facingMode,
                }}
              />
            ) : (
              <img src={image} />
            )}
          </div>
          <div>
            {image != "" ? (
              <>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setImage("");
                  }}
                  className="btn btn-success mx-2"
                >
                  Retake Image
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleClose(false);
                  }}
                  className="btn btn-warning mx-2"
                >
                  Close
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    capture();
                  }}
                  className="btn btn-success mx-2"
                >
                  Capture
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleClose(false);
                  }}
                  className="btn btn-warning mx-2"
                >
                  Close
                </button>
                {isMobile && (
                  <button
                    type="button"
                    onClick={handleChangeMode}
                    className="btn btn-secondary mx-2"
                  >
                    Switch camera
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <button
          className="btn btn-warning btn-sm"
          disabled={disabled}
          onClick={() => handleShow(true)}
        >
          Open Camera
        </button>
      )}
    </>
  );
};

const IncomeProof = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [icpType, setIcpType] = useState("");
  useEffect(() => {
    console.log('icpType', icpType)
  }, [icpType]);
  const [icpProof, setIcpProof] = useState("");
  const [isShow, setIsShow] = useState(false);
  const [options, setOptions] = useState([]);
  const { inputLabelColor } = useSelector((state) => state.theme);
  const { kycStatus, kycPageName } = useSelector((state) => state.navigation);
  const [imgCapture, setImgCapture] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectCaptureImg, setSelectCaptureImg] = useState(null);


  const optionListVACHANA = ["Bank Statement (Latest 6 Months)", "ITR (Latest ITR Acknowledgement)", "Payslip (Latest 3 month's Salary Slip)"];

  useEffect(() => {
    let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
    API_URL_NEW = API_URL_NEW
      ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
      : "";
    const optionList = ["Bank Statement", "ITR", "Payslip"];
    const optionListVACHANA = ["Bank Statement (Latest 6 Months)", "ITR (Latest ITR Acknowledgement)", "Payslip (Latest 3 month's Salary Slip)"];
    if (API_URL_NEW === "https://scmcbrke.in") {
      optionList.pop();
    }
    if (API_URL_NEW == VACHANA_API_URL) {
      setOptions(optionListVACHANA);
    } else {
      setOptions(optionList);
    }

  }, []);

  const checkIfPageNeeded = () => {
    dispatch(setLoading(true));
    let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
    API_URL_NEW = API_URL_NEW
      ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    axios
      .get(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_flow.api.get_client_segment_detail`,
        headers
      )
      .then((result) => {
        dispatch(setLoading(false));
        let { data } = result.data;
        let isShow = false;
        for (let i in data) {
          if (data[i].segment == "Capital Market") {
            if (data[i].mcx) {
              isShow = true;
            }
            if (data[i].ncdex) {
              isShow = true;
            }
          }
          if (data[i].segment == "Currency Derivative") {
            if (data[i].bse) {
              isShow = true;
            }
            if (data[i].nse) {
              isShow = true;
            }
            if (data[i].ncdex) {
              isShow = true;
            }
            if (data[i].mcx) {
              isShow = true;
            }
            if (data[i].msei) {
              isShow = true;
            }
          }
          if (data[i].segment == "SLB") {
            if (data[i].bse) {
              isShow = true;
            }
            if (data[i].nse) {
              isShow = true;
            }
            if (data[i].ncdex) {
              isShow = true;
            }
            if (data[i].mcx) {
              isShow = true;
            }
            if (data[i].msei) {
              isShow = true;
            }
          }
          if (data[i].segment == "Commodities") {
            if (data[i].bse) {
              isShow = true;
            }
            if (data[i].nse) {
              isShow = true;
            }
            if (data[i].ncdex) {
              isShow = true;
            }
            if (data[i].mcx) {
              isShow = true;
            }
            if (data[i].msei) {
              isShow = true;
            }
          }
          if (data[i].segment == "Future and Option") {
            if (data[i].bse) {
              isShow = true;
            }
            if (data[i].nse) {
              isShow = true;
            }
            if (data[i].ncdex) {
              isShow = true;
            }
            if (data[i].mcx) {
              isShow = true;
            }
            if (data[i].msei) {
              isShow = true;
            }
          }
        }
        if (!isShow) {
          dispatch(
            updateNavigationKycStatus({
              pageName: "IncomeProof",
              status: 1,
            })
          );
        }
      })
      .catch((error) => {
        if (error.response?.data?.message === "No segments found in use KYC") {
          dispatch(
            updateNavigationKycStatus({
              pageName: "IncomeProof",
              status: 1,
            })
          );
        }
        dispatch(setLoading(false));
      });
  };

  useEffect(() => {
    checkIfPageNeeded();
  }, []);

  useEffect(() => {
    dispatch(getSegments());
  }, [dispatch]);

  // const handleFile = async (e) => {
  //   // dispatch(setLoading(true));
  //   let file = e.target.files[0];
  //   if (file) {
  //     const allowed_types = ["application/pdf"];
  //     if (!allowed_types.includes(file.type)) {
  //       toast.error("Only PDF are allowed", "Error");
  //       e.target.value = null;
  //       return;
  //     }
  //     setIsShow(false);
  //     let { name } = e.target.files[0];
  //     let makeArr = name.split(".");
  //     let ext = makeArr[makeArr.length - 1];

  //     e.target.value = null;
  //     const formData = new FormData();
  //     formData.append("icp_type", icpType);
  //     file && formData.append("file", file, makeid(6) + "." + ext);
  //     formData.append("file_type", "Image");
  //     dispatch(handleFileUpload(formData));
  //   }
  // };

  const handleFile = async (file) => {
    if (!file) return;
    const allowed_types = ["application/pdf"];
    if (!allowed_types.includes(file.type)) {
      toast.error("Only PDF are allowed", "Error");
      return;
    }
    const fileSize = file.size / 1024 ** 2;
    if (fileSize >= 10) {
      toast.error("Please upload a file smaller than 10MB");
      return;
    }
    setIcpProof(file);
    setIsShow(false);
    let isEncrypted = false;
    const formData = new FormData();
    let makeArr = file.name.split(".");
    let ext = makeArr[makeArr.length - 1];
    dispatch(setLoading(true));
    try {
      formData.append("file", file, makeid(6) + "." + ext);
      const resp = await validateIncomeProof(formData);
      isEncrypted = resp.data?.message || false;
      console.log("isEncrypted", isEncrypted);
      dispatch(setLoading(false));
      let icp = icpType;
      if (icpType == 'Bank Statement (Latest 6 Months)') {
        icp = 'Bank Statement';
      } else if (icpType == 'ITR (Latest ITR Acknowledgement)') {
        icp = 'ITR';
      } else if (icpType == 'Payslip (Latest 3 month\'s Salary Slip)') {
        icp = 'Payslip';
      }
      if (isEncrypted) {
        let passcode = prompt("Please enter your pdf password", "");
        if (passcode) {
          formData.append("icp_type", icp);
          formData.append("file_type", "Image");
          formData.append("is_encrypted", 1);
          formData.append("passcode", passcode);
          dispatch(handleFileUpload(formData));
        }
      } else {
        formData.append("icp_type", icp);
        formData.append("file_type", "Image");
        formData.append("is_encrypted", 0);
        dispatch(handleFileUpload(formData));
      }
    } catch (error) {
      console.log("err", error);
      dispatch(setLoading(false));
    }
  };

  const uploadCaptureFile = (file) => {
    // dispatch(setLoading(true));
    let formData = new FormData();
    formData.append("icp_type", icpType);
    formData.append("file", file?.replace("data:image/jpeg;base64,", ""));
    formData.append("file_type", "Base64");
    dispatch(handleCaptureFileUpload(formData));
  };

  function dataURLtoFile(dataurl, imgSrc, filename) {
    let src = imgSrc.src;
    console.log(src);
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const fileToImageURL = (file) => {
    return new Promise((resolve, reject) => {
      const image = new Image(file.type);
      image.onload = () => {
        resolve(image);
      };
      image.onerror = () => {
        reject(new Error("Failed to convert File to Image"));
      };
      image.src = URL.createObjectURL(file);
    });
  };

  const handleCaptureFile = async (img) => {
    // uploadCaptureFile(img);
    let imgSrc = await fileToImageURL(dataURLtoFile(img, `${Date.now()}.jpeg`));
    setImgCapture([...imgCapture, { src: imgSrc.src }]);
  };

  const deleteCaptureFile = (item) => {
    const filter = imgCapture.filter((y) => y !== item);
    setImgCapture(filter);
  };

  const viewCaptureFile = (file) => {
    setOpenModal(true);
    setSelectCaptureImg(file);
  };

  const handleShow = (bool) => {
    setIsShow(bool);
  };

  const handleSubmit = async () => {
    const doc = new jsPDF();
    doc.deletePage(1);
    imgCapture.forEach((image) => {
      doc.addPage();
      doc.addImage(image.src, "jpeg", 0, 96, 210, 105);
    });
    const pdfURL = doc.output("bloburl");
    console.log("pdfURL", pdfURL);
    // window.open(pdfURL, "_blank");
    let blob = await fetch(pdfURL).then((r) => r.blob());
    console.log("blob", blob);


    let icp = icpType;
    if (icpType == 'Bank Statement (Latest 6 Months)') {
      icp = 'Bank Statement';
    } else if (icpType == 'ITR (Latest ITR Acknowledgement)') {
      icp = 'ITR';
    } else if (icpType == 'Payslip (Latest 3 month\'s Salary Slip)') {
      icp = 'Payslip';
    }
    // const optionList = ["Bank Statement", "ITR", "Payslip"];
    //     const optionListVACHANA = ["Bank Statement (Latest 6 Months)", "ITR (Latest ITR Acknowledgement)", "Payslip (Latest 3 month's Salary Slip)"];

    const formData = new FormData();
    formData.append("icp_type", icp);
    formData.append("file", blob);
    formData.append("file_type", "Image");
    dispatch(handleFileUpload(formData));
  };

  return (
    <React.Fragment>
      <Title title="Income Proof (Pdf)" />
      <form className="mx-3">
        <div className="row">
          <div className="col-md-12 mt-3 ">
            <div onChange={(e) => setIcpType(e.target.value)}>
              {options.map((item, i) => {
                return (
                  <div
                    className="m-2"
                    key={i}
                    style={{ color: inputLabelColor }}
                  >
                    <input
                      type="radio"
                      value={item}
                      name={item}
                      checked={item === icpType}
                    />{" "}
                    {item}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="row">
            <div className="col-md-7">
              <div className="form-group">
                <InputTitle
                  title={
                    icpType === "Bank Statement" || icpType === "Bank Statement (Latest 6 Months)"
                      ? "Please Upload 6 Months Bank Statement."
                      : "Upload Document"
                  }
                  className={"my-1"}
                />
                <div className="file-uploader-container">
                  <FileUploader
                    handleChange={(file) => handleFile(file)}
                    name="file"
                    types={["PDF"]}
                    disabled={!icpType}
                  />
                </div>
                {icpProof?.name && (
                  <p>
                    <small>File name: {icpProof.name}</small>
                  </p>
                )}
                {/* <input
                  type="file"
                  onChange={handleFile}
                  className="form-control"
                  accept="application/pdf"
                  disabled={!icpType}
                /> */}
                <label className="my-1 text-muted text-sm">
                  <small>Maximum file size: 4 MB</small>
                </label>
                {/* {loading && "Loading..."} */}
              </div>
            </div>

            <div className="col-md-5">
              <div className="row mt-1">
                {/* <div style={{ width: 300, margin: "0 auto" }}>
                {imgCapture.map((item, index) => (
                  <div style={{ display: "flex" }}>
                    <li key={index}>image{`${index + 1}`}</li>
                    <button
                      type="button"
                      className="btn btn-sm"
                      onClick={() => viewCaptureFile(item)}
                    >
                      View
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm"
                      onClick={() => deleteCaptureFile(item)}
                    >
                      Delete
                    </button>
                  </div>
                ))}
              </div> */}
                <DragDropContext>
                  <Droppable droppableId="characters">
                    {(provided) => (
                      <ul
                        className="characters"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {imgCapture.map((item, index) => {
                          return (
                            <Draggable
                              key={index.toString()}
                              draggableId={index.toString()}
                              index={index}
                            >
                              {(provided) => (
                                <li
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <span>image{`${index + 1}`}</span>
                                  <div style={{ dsiplay: "flex" }}>
                                    <button
                                      type="button"
                                      className="btn btn-sm"
                                      onClick={() => viewCaptureFile(item)}
                                    >
                                      View
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm"
                                      onClick={() => deleteCaptureFile(item)}
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </li>
                              )}
                            </Draggable>
                          );
                        })}
                      </ul>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
              <div className="row mt-1">
                {imgCapture.length < 10 && (
                  <div style={{ position: "relative" }}>
                    <WebcamCapture
                      handleImg={handleCaptureFile}
                      handleShow={handleShow}
                      show={isShow}
                      disabled={!icpType}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {imgCapture.length > 0 && (
            <div className="col-md-12 mt-3">
              <Button
                type="button"
                title="Submit"
                handleClick={handleSubmit}
              />
            </div>
          )}

          <div className="col-md-12 mt-3">
            <div className="d-flex">
              {showPrevBtnByUrl(
                history.location.pathname,
                kycStatus,
                kycPageName
              ) && (
                  <Button
                    title="Previous"
                    type="button"
                    className="mx-1"
                    handleClick={() => {
                      const route = getPrevAndNextRoute(
                        history.location.pathname.slice(1),
                        kycPageName
                      );
                      history.push(route.prev);
                    }}
                  />
                )}
              {showNextBtnByUrl(
                history.location.pathname,
                kycStatus,
                kycPageName
              ) && (
                  <Button
                    title="Next"
                    type="button"
                    className="mx-1"
                    handleClick={() => {
                      const route = getPrevAndNextRoute(
                        history.location.pathname.slice(1),
                        kycPageName
                      );
                      history.push(route.next);
                    }}
                  />
                )}
            </div>
          </div>
        </div>
      </form>

      <ViewModel
        show={openModal}
        handleClose={setOpenModal}
        item={selectCaptureImg}
      />
    </React.Fragment>
  );
};

export default IncomeProof;
